export default "__VITE_ASSET__RMhjee_Z__"